import { GridRowSelectionModel } from '@mui/x-data-grid';
import { GridSortItem } from '@mui/x-data-grid/models/gridSortModel';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { IObject } from '../interfaces/IObject';

interface ReportState {
  filters: IObject;
  sorting: GridSortItem[];
  pageNumber: number;
  refreshKey: number;
  selectedRow: GridRowSelectionModel;
}

const initialState: ReportState = {
  filters: {
    created_by: null,
    created_on: null,
    type: null,
    frequency: null,
    next_triggered_date: null,
    recipients: null,
  },
  sorting: [],
  pageNumber: 0,
  refreshKey: 0,
  selectedRow: { type: 'include', ids: new Set() },
};

const reportSlice = createSlice({
  name: 'report',
  initialState,
  reducers: {
    setFilters: (state, action: PayloadAction<IObject>) => {
      state.filters = action.payload;
    },
    setSorting: (state, action: PayloadAction<GridSortItem[]>) => {
      state.sorting = action.payload;
    },
    setPageNumber: (state, action: PayloadAction<number>) => {
      state.pageNumber = action.payload;
    },
    setRefreshKey: (state, action: PayloadAction<number>) => {
      state.refreshKey = action.payload;
    },
    setSelectedRow: (state, action: PayloadAction<GridRowSelectionModel>) => {
      state.selectedRow = action.payload;
    },
  },
});

export const {
  setFilters,
  setSorting,
  setPageNumber,
  setRefreshKey,
  setSelectedRow,
} = reportSlice.actions;

export default reportSlice.reducer;
